import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Http } from '../../support';
import { useStore } from '../../store';
import ReceptoresList from './list/ReceptoresList';
import LoadingButton from '../../facturotopia/LoadingButton';
import ReceptoresSearch from './list/components/ReceptoresSearch';
import ReceptoresItemActions from './list/components/ReceptoresItemActions';

class Receptores extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Receptores');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = async (data) => {
    await this.props.infoActions.setPartialState({ data });
    await this.props.upsertActions.setPartialState({ data });

    this.props.history.replace({
      pathname: `/app/receptores/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true,
    });

    try {
      const { filters } = this.props.receptores;

      const params = {
        download: 1,
        ...filters,
      };

      const response = await Http.get(`${window.BONJOUR_URL}/api/receptores`, { params, responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar los receptores',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { selectedRowKeys, selectedRows, busy } = this.state;

    return (
      <div>
        <Row className="mb-3">
          <Col
            xs={12}
            sm={6}
            md={4}
            lg={4}
          >
            {Guardian.allows(['receptor.crear']) && (
              <Link
                to="/app/receptores/registrar"
                className="mr-3"
              >
                <Button>Nuevo receptor</Button>
              </Link>
            )}

            {Guardian.allows('receptor.descargar') && (
              <LoadingButton
                variant="secondary"
                onClick={this.handleOnDownloadActionClick}
              >
                {busy === true ? 'Descargando' : 'Descargar'}
              </LoadingButton>
            )}

            {selectedRowKeys.length > 0 && (
              <ReceptoresItemActions
                selectedRowKeys={selectedRowKeys}
                selectedRows={selectedRows}
              />
            )}
          </Col>

          <Col
            xs={12}
            sm={4}
            md={6}
            lg={6}
            className="text-right"
          >
            {Guardian.allows('receptor.listar.archivos') && <ReceptoresSearch />}
          </Col>

          {Guardian.allows('receptor.crear.excel') && (
            <Col
              sm="auto"
              md={2}
              className="text-right"
            >
              <Button
                variant="link"
                as={Link}
                className="text-secondary"
                to="/app/receptores/archivos"
              >
                Cargar excel <FontAwesomeIcon icon={['fas', 'chevron-right']} />
              </Button>
            </Col>
          )}
        </Row>

        {Guardian.allows('receptor.listar') && (
          <ReceptoresList
            onRowClick={this.handleOnRowClick}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </div>
    );
  }
}

const mapState = (store) => {
  return {
    list: store.app.receptores.list,
    info: store.app.receptores.info,
    upsert: store.app.receptores.upsert,
  };
};

const mapActions = (actions) => {
  return {
    infoActions: actions.app.receptores.info,
    upsertActions: actions.app.receptores.upsert,
  };
};

export default connect(useStore, mapState, mapActions)(Receptores);
